import { Service } from "@roc/feature-app-core";

const url = {
  GET_LOAN_TO_DOS: '/api/v1/loan/loanToDo/getLoanToDos',
  SEND_REPLY_IN_TASK_MESSAGE: '/api/v1/vendor/twilio/taskChatRoomV2/sendReplyInTaskMessage',
};

export class ReplyInTaskService extends Service {

  getLoanTaskOptions(loanId, loanProcess, processId, showAllToDos, priorities) {
    return this.get(`${url.GET_LOAN_TO_DOS}/${loanId}`, { loanProcess, showAllToDos, processId, priorities });
  }

  sendReplyInTaskMessage(request) {
    return this.post(url.SEND_REPLY_IN_TASK_MESSAGE, request);
  }

}